import { createReducer } from '@reduxjs/toolkit';

import * as actionTypes from '../../actionTypes';

/** @typedef {boolean} IsChatModalOpenState */

/** @type {IsChatModalOpenState} */
const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.OPEN_CHAT_MODAL, open)
    .addCase(actionTypes.CLOSE_CHAT_MODAL, close);
});
